import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class AcordaoService extends Service {
    async transferirAcordao(sessao, processos) {
        return this.getAcordaoApi().transferirAcordao(sessao, processos);
    }

    async validarAcordao(idSessao, numeroProcesso, validado) {
        return this.getAcordaoApi().validarAcordao(idSessao, numeroProcesso, validado);
    }

    async marcarAcordaoObrigatorio(idSessao, numeroProcesso, acordaoObrigatorio) {
        return this.getAcordaoApi().marcarAcordaoObrigatorio(idSessao, numeroProcesso, acordaoObrigatorio);
    }

    async devolverAcordao(idSessao, numeroProcesso, observacao) {
        return this.getAcordaoApi().devolverAcordao(idSessao, numeroProcesso, observacao);
    }
}

export default AcordaoService;
